import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/modules/data-steward.constants";
import { GetEntityPropertyDataResponse, PushOverriddenValueResponse, GetEntityPropertyDataHistoryResponse, MdrMapping } from "../../models/data-steward/data-steward.models";

//Needs to be singleton because of cached promises
@autoinject()
export class DataStewardClientService {

    private _loadMdrMappingsPromise: Promise<MdrMapping[]>;
    private _loadMdrMappings: MdrMapping[];
    
    constructor(private requestClient: RequestClientService) { }

    public async loadMdrMappings(): Promise<MdrMapping[]> {
        if (!this._loadMdrMappingsPromise) {
            this._loadMdrMappingsPromise = this.requestClient.get(Urls.GetMdrMappings, {});
        }
        if(!this._loadMdrMappings){

            this._loadMdrMappings = await this._loadMdrMappingsPromise;
        }
        return this._loadMdrMappings;
    }

    public getEntityPropertyData(entityId: number, entityTypeId: number, properties: string[]): Promise<GetEntityPropertyDataResponse[]> {
        return this.requestClient.post(Urls.GetEntityValuesFromSources, {}, { entityId, entityTypeId, properties });
    }

    public getEntityPropertyDataHistory(entityId: number, entityTypeId: number, properties: string[]): Promise<GetEntityPropertyDataHistoryResponse[]> {
        return this.requestClient.post(Urls.GetEntityPropertyDataHistory, {}, { entityId, entityTypeId, properties });
    }

    public pushOverriddenValue(entityId: number, entityTypeId: number, overriddenValues: { propertyName: string, overriddenValue: any, sourceComment: string }[]): Promise<PushOverriddenValueResponse> {
        return this.requestClient.post(Urls.PushOverriddenValues, {}, { entityIds: [entityId], entityTypeId, overriddenValues: overriddenValues });
    }
}